import { Button } from "primereact/button";
import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as Vehicle } from "assets/images/vehicle.svg";
import EditIcon from "assets/images/icons/Row_Edit_Action.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/Row_Delete_Actions.svg";
import CalendarIcon from "assets/images/icons/components/CalendarIcon";
import { ReactComponent as ReloadIcon } from "assets/images/reload.svg";
import palte from "assets/images/vehicle-plate.png";

import { Divider } from "@mui/material";
import { Calendar } from "primereact/calendar";
import {
  BUSINESS_LINE_COLORS,
  BUSINESS_LINE_PATHS,
  getExtraMotorMainColor,
  getFormErrorMessage,
  isFormFieldValid,
} from "helpers/utils";
import { useFormik } from "formik";
import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { useDispatch } from "react-redux";
import { updateLoading } from "redux/actions/commonActions";
import {
  getDefaultValues,
  getModelsByMakeCode,
  getMotorMakes,
  getMotorColor,
} from "services/motorRetailService";
import {
  removeVehicle,
  updateLocalVehicleDetails,
  changedDeductable,
} from "redux/actions/motorActions";
import { checkMissingData } from "application/motor/helpers/utils";
import {
  ConvertToArabicNumbers,
  ConvertToEnglishLetters,
} from "helpers/plate-number-converter.util";
import config from "application/motor/helpers/config";
import StyleWrapper from "./style";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";

const VehiclePreview = ({
  vehicle,
  serialNumber,
  allowEdit,
  hideDelete,
  hideVehicleValue,
  hideDeduct,
  autoSubmit,
  opened,
  loadProposals,
  autoNextButton,
  nextButtonHandler,
  setIsNextButtonActive,
}) => {
  const [t, i18n] = useTranslation();
  const [models, setModels] = useState([]);
  const [makes, setMakes] = useState([]);
  const [colorlist, setColorlist] = useState([]);
  const [carToEdit, setCarToEdit] = useState(opened ? vehicle : null);
  const [autoSubmitFlag, setAutoSubmitFlag] = useState(autoSubmit);
  const [defaultValues, setDefaultValues] = useState(null);
  const dispatch = useDispatch();
  const currentLanguageCode = i18n.language;
  const toast = useRef(null);
  const [UpdateVehicaleValue, setUpdateVehicaleValue] = useState({});
  const { businessLine } = useParams();

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.BSF) businessColor = BUSINESS_LINE_COLORS.BSF;
  else if (businessLine === BUSINESS_LINE_PATHS.STC) businessColor = BUSINESS_LINE_COLORS.STC;
  else if (businessLine === BUSINESS_LINE_PATHS.LUCID) businessColor = BUSINESS_LINE_COLORS.LUCID;
  else if (businessLine === BUSINESS_LINE_PATHS.CARTRUST)
    businessColor = BUSINESS_LINE_COLORS.CARTRUST;
  else if (businessLine === BUSINESS_LINE_PATHS.SYARAH) businessColor = BUSINESS_LINE_COLORS.SYARAH;
  else if (businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === BUSINESS_LINE_PATHS.ALNAGHI)
    businessColor = BUSINESS_LINE_COLORS.ALNAGHI;
  else if (businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB;
  else if (businessLine === BUSINESS_LINE_PATHS.PETROMIN)
    businessColor = BUSINESS_LINE_COLORS.PETROMIN;

  const businessColorStyleObj = { color: businessColor };

  useEffect(() => {
    TriggerColorApi();
    const request = {
      languageCode: currentLanguageCode?.slice(0, 1)?.toUpperCase(),
      productCode: "ALL",
    };
    getMotorMakes(request, businessLine).then((res) => {
      setMakes(res.data.makeDetailsArray);
    });
    if (opened || carToEdit) {
      dispatch(updateLoading(true));
      getModelsByMakeCode(vehicle?.makeCode, businessLine).then(({ data }) => {
        dispatch(updateLoading(false));
        const { modelDetailsArray } = data;

        vehicle.makeCode && vehicle?.modelCode && getCarDefaultValues(vehicle?.modelCode);
        const modelListRemapped = modelDetailsArray?.map((model) => ({
          id: model.modelCode,
          name: model.description,
          ...model,
        }));
        // modelListRemapped.pop();
        setModels(modelListRemapped);
      });
    }
  }, [carToEdit]);

  const handlePaste = (e) => {
    e.preventDefault();

    // Clear the clipboard content after a short timeout
    setTimeout(() => {
      const input = document.getElementsByName("vehicleValue")[0];
      input.value = "";
    }, 0);
  };
  const TriggerColorApi = async () => {
    const request = {
      languageCode: currentLanguageCode?.slice(0, 1)?.toUpperCase(),
      colorCode: "",
      channelDetails: {
        applicationCategory: "RH",
        branchCode: "85",
        sourceCode: "550541",
        applicationType: "RHSP",
        userName: "EBUSUSER",
        channelCode: "85",
      },
    };
    getMotorColor(request, businessLine).then((res) => {
      setColorlist(res.data.detailsArray);
    });
  };

  const getCarDefaultValues = async (modelCode) => {
    if (modelCode.length > 0) {
      let NewYOM = carToEdit?.yearOfManufacture;
      let NewMOD = modelCode;
      let NewMAke = carToEdit?.makeCode;

      getDefaultValues(
        {
          productCode: "ALL",
          yearOfManufacture: carToEdit?.yearOfManufacture
            ? carToEdit?.yearOfManufacture
            : UpdateVehicaleValue?.yearOfManufacture,
          modelCode: modelCode,
          makeCode: carToEdit?.yearOfManufacture
            ? carToEdit?.makeCode
            : UpdateVehicaleValue?.makeCode,
          chassisNumber: vehicle.chassisNumber,
          languageCode: currentLanguageCode?.slice(0, 1)?.toUpperCase(),
          channelDetails: {
            applicationCategory: "RH",
            applicationType: "RHSP",
            branchCode: "85",
            channelCode: "85",
            sourceCode: "755897",
            userName: "FRS2050001",
          },
        },
        businessLine
      ).then((res) => {
        const temp = res.data;
        if (temp?.resultCode === "V") {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: temp?.resultMessage,
            life: 6000,
          });
        } else {
          if (temp?.vehicleValue?.avg)
            temp.vehicleValue.avg = parseInt(temp.vehicleValue.avg.toString()).toString();
          setDefaultValues({ ...temp.vehicleValue });
          ////     // console.log(temp);
          formik.setValues({
            yom: vehicle.yearOfManufacture || "",
            modelCode: vehicle.modelCode ? vehicle.modelCode : modelCode,
            vehicleValue: vehicle.vehicleValue || temp?.vehicleValue?.avg || "",
            deductible: vehicle?.deductible || temp?.deductible || temp?.deductibleUnifiedForm,
            colorCode: vehicle?.colorCode || temp?.colorCode,
          });
        }

        if (autoSubmit && autoSubmitFlag) {
          setTimeout(() => {
            formik.submitForm();
          }, 500);
        }
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      yom: vehicle.yearOfManufacture || "",
      modelCode: vehicle?.modelCode || "",
      vehicleValue: vehicle?.vehicleValue || defaultValues?.avg || "",
      deductible: vehicle?.deductible || vehicle?.deductibleUnifiedForm || "3500",
      makeCode: vehicle?.makeCode,
      colorCode: vehicle?.colorCode,
    },
    validate: (data) => {
      let errors = {};

      if (!data.yom) {
        errors.yom =
          currentLanguageCode == "en" ? "Year of manufacture is required." : "سنة الصنع مطلوبة";
      }
      if (!data.colorCode) {
        errors.colorCode =
          currentLanguageCode == "en" ? "Please select Color." : "لون المركبة مطلوب";
      }
      if (!data.modelCode) {
        errors.modelCode =
          currentLanguageCode == "en" ? "model is required." : "موديل السيارة مطلوب";
      }
      if (!vehicle.makeCode && !data.makeCode) {
        errors.makeCode =
          currentLanguageCode == "en" ? "make is required." : "المصنع السيارة مطلوب";
      }

      if (!data.vehicleValue) {
        errors.vehicleValue =
          currentLanguageCode == "en" ? "Vehicle value is required." : "قيمة السيارة مطلوبة";
        setIsNextButtonActive(false);
      } else if (
        +data?.vehicleValue < +defaultValues?.min ||
        +data?.vehicleValue > +defaultValues?.max
      ) {
        errors.vehicleValue =
          currentLanguageCode == "en"
            ? `Vehicle value must be between `
            : ` يجب أن تتراوح قيمة السيارة بين`;
      }

      if (!data.deductible) {
        errors.deductible =
          currentLanguageCode == "en"
            ? "Deductible value is required."
            : "القيمة القابلة للخصم مطلوبة";
      }

      return errors;
    },
    onSubmit: (data) => {
      console.log("DHT", makes, models, colorlist);
      const model = models.find((ele) => ele.id === data.modelCode);
      const make = makes.find((ele) => ele.makeCode === data?.makeCode);

      const colors = colorlist.find((ele) => ele.colorCode === data?.colorCode);
      const myVehicle = {
        ...vehicle,
        modelCode: data.modelCode,
        modelName: model.name,
        yearOfManufacture: new Date(data.yom).getFullYear().toString(),
        deductible: data.deductible.toString(),
        vehicleValue: data.vehicleValue.toString(),
        seatingCapacity: model.seatCapacity || "4",
        colorCode: colors.colorCode,
        colorName: colors.colorDescription,
      };
      if (!vehicle.makeCode) {
        myVehicle.makeCode = make.makeCode;
        myVehicle.makeName = make.description;
      }
      dispatch(updateLocalVehicleDetails(myVehicle));
      dispatch(changedDeductable());
      setCarToEdit(null);
      setUpdateVehicaleValue(myVehicle);
      setAutoSubmitFlag(null);
      console.log("nav1", myVehicle);

      console.log("nav2", UpdateVehicaleValue);

      if (autoNextButton) nextButtonHandler();
    },
  });

  useEffect(() => {
    if (!vehicle.makeCode) {
      getModelsByMakeCode(formik.values.makeCode, businessLine).then(({ data }) => {
        const { modelDetailsArray } = data;
        const modelListRemapped = modelDetailsArray?.map((model) => ({
          id: model.modelCode,
          name: model.description,
          ...model,
        }));
        setModels(modelListRemapped);
      });
    }
  }, [formik.values.makeCode]);

  const navigate = useNavigate();

  useEffect(() => {
    getCarDefaultValues(formik.values.modelCode);
  }, [formik.values.modelCode]);

  const handleVehicleRemove = (vehicle) => {
    dispatch(removeVehicle(vehicle));
    navigate("/vehicle-details");
  };


  console.log("defaultValues : ", defaultValues);
  return (
    <StyleWrapper className="preview_wrapper mt-2 mb-4">

      <Toast ref={toast} />
      <div
        className={`vehicle-item whitebg ${
          checkMissingData(vehicle) && allowEdit ? "missing" : ""
        }`} // missing class
        key={vehicle.chassisNumber}
      >
        <div className="vehicle-details">
          <Vehicle />
          <div className="d-inline-flex flex-column details">
            <p className="m-0 title">
              <span style={businessColorStyleObj}>{i18n.t("MotorEn.VehicleValue")}</span>
            </p>
            <p className="m-0 text-bold isEnglish">{vehicle.vehicleValue}</p>
          </div>

          <div className="d-inline-flex flex-column details">
            <p className="m-0 title">
              <span style={businessColorStyleObj}>{i18n.t("MotorEn.Make")}</span>-{" "}
              {i18n.t("MotorEn.Model")}
            </p>
            <p className="m-0 text-bold">
              <span style={businessColorStyleObj}>{vehicle.makeName}</span>
              {vehicle.modelName && ` - ${vehicle.modelName}`}
              {" -"} {vehicle.colorName}
            </p>
          </div>

          {!hideDeduct && (
            <div className="d-inline-flex flex-column details">
              <p className="m-0 title">
                <span style={businessColorStyleObj}>{i18n.t("MotorEn.Deductible")}</span>
              </p>
              <p className="m-0 text-bold isEnglish">{vehicle.deductible}</p>
            </div>
          )}

          {/* deduct ended*/}

          {serialNumber && (
            <div className="plate">
              <div className="plate-wrapper">
                <span className="numbers ar">{ConvertToArabicNumbers(vehicle.plateNumber)}</span>
                <span className="numbers en">{vehicle.plateNumber}</span>
                <span className="chars ar">
                  {vehicle.plateTextRight} {vehicle.plateTextMiddle} {vehicle.plateTextLeft}
                </span>
                <span className="chars en">
                  {ConvertToEnglishLetters(
                    vehicle.plateTextRight +
                      "" +
                      vehicle.plateTextMiddle +
                      "" +
                      vehicle.plateTextLeft
                  )}
                </span>
                <img src={palte} alt="" />
              </div>
            </div>
          )}

          {!carToEdit && (
            <div className="d-inline-flex justify-content-between align-items-center gap-1">
              {allowEdit && (
                <Button
                  onClick={() => setCarToEdit(vehicle)}
                  className="p-button-rounded p-button-outlined edit p-0"
                  style={{ borderColor: businessColor }}
                >
                  <img src={EditIcon} alt="" />
                </Button>
              )}
              {!hideDelete && (
                <Button
                  className="p-button-rounded p-button-outlined remove p-0"
                  onClick={() => handleVehicleRemove(vehicle)}
                  style={{ borderColor: businessColor }}
                >
                  <TrashIcon />
                </Button>
              )}
            </div>
          )}
        </div>
        {carToEdit && (
          <React.Fragment>
            <Divider className="my-3" />
            <form className="row" onSubmit={formik.handleSubmit}>
              <p className="form-title mb-3">{i18n.t("MotorEn.MissingInformation")}</p>
              {!vehicle.makeCode && (
                <div className="field col-md-6 col-xs-12 my-3">
                  <span className="p-float-label">
                    <Dropdown
                      className={classNames({
                        "w-100": true,
                        "p-invalid": isFormFieldValid(formik, "modelCode"),
                      })}
                      value={formik.values.makeCode}
                      disabled={vehicle?.makeCode}
                      name="makeCode"
                      onChange={formik.handleChange}
                      options={makes}
                      optionValue="makeCode"
                      optionLabel="description"
                      filter
                      filterBy="description"
                    />
                    <label className="w-100 label" htmlFor="">
                      {i18n.t("MotorEn.Make")}
                    </label>
                  </span>
                  {getFormErrorMessage(formik, "makeCode")}
                </div>
              )}

              <div id="modelCodeId" className="field col-md-6 col-xs-12 my-3">
                <span className="p-float-label">
                  <Dropdown
                    className={classNames({
                      "w-100": true,
                      "p-invalid": isFormFieldValid(formik, "modelCode"),
                    })}
                    value={formik.values.modelCode}
                    disabled={vehicle?.modelCode}
                    name="modelCode"
                    optionValue={"id"}
                    onChange={formik.handleChange}
                    onMouseDown={() => {
                      const modelCodeIdOffsets = document
                        .getElementById("modelCodeId")
                        .getBoundingClientRect();
                      const timer = setTimeout(() => {
                        const dropdown = document.querySelector(".p-dropdown-panel");
                        if (dropdown) {
                          dropdown.style.width = modelCodeIdOffsets.width + "px";
                          dropdown.style.left = modelCodeIdOffsets.left + "px";
                          clearTimeout(timer);
                        }
                      }, 230);
                    }}
                    options={models}
                    optionLabel="name"
                    filter
                    showClear
                    filterBy="name"
                  />
                  <label className="w-100 label" htmlFor="">
                    {i18n.t("MotorEn.Model")}
                  </label>
                </span>
                {getFormErrorMessage(formik, "modelCode")}
              </div>

              <div className="field col-md-6 col-xs-12 my-3">
                <span className="p-input-icon-left w-100 position-relative">
                  <label htmlFor="yom" className="yomLabel w-100 label">
                    {i18n.t("MotorEn.YearManufacture")}
                  </label>
                  <Calendar
                    id="yom"
                    showIcon
                    icon={<CalendarIcon color={businessColor} />}
                    iconPos={"left"}
                    view="year"
                    dateFormat="yy"
                    maxDate={new Date()}
                    name="yom"
                    disabled={vehicle?.yearOfManufacture}
                    value={new Date(formik.values.yom)}
                    onChange={formik.handleChange}
                    className="w-100"
                    inputClassName={classNames({
                      "p-invalid": isFormFieldValid(formik, "yom"),
                      "fm-tawuniya": true,
                    })}
                    readOnlyInput
                    placeholder={i18n.t("MotorEn.YearManufacture")}
                  />
                </span>
                {getFormErrorMessage(formik, "yom")}
              </div>

              {(!defaultValues?.vehicleValue || !hideVehicleValue) && (
                <div className="field col-md-6 col-xs-12 my-3">
                  <div className="p-inputgroup position-relative">
                    <label htmlFor="" className="yomLabel w-100 label">
                      {i18n.t("MotorEn.VehicleValue")}
                    </label>
                    <InputNumber
                      placeholder={i18n.t("MotorEn.VehicleValue")}
                      name="vehicleValue"
                      value={formik.values.vehicleValue}
                      maxLength={10}
                      onChange={(e) => {
                        if (!e?.value || e?.value?.toString().trim().length < 9)
                          formik.setFieldValue("vehicleValue", e.value);
                      }}
                      onPaste={handlePaste}
                      min={0}
                      autoFocus
                      className={classNames({
                        "p-invalid": isFormFieldValid(formik, "vehicleValue"),
                        "fm-tawuniya": true,
                      })}
                    />
                    <span className="p-inputgroup-addon bg-transparent border-none">
                      {i18n.t("POLICY.SAR")}
                    </span>
                  </div>
                  {getFormErrorMessage(formik, "vehicleValue") ? (
                    <span>
                      {getFormErrorMessage(formik, "vehicleValue")}{" "}
                      {formik.values.vehicleValue &&
                        (+formik.values?.vehicleValue < +defaultValues?.min ||
                          +formik.values?.vehicleValue > +defaultValues?.max) && (
                          <small className="p-error fm-tawuniya">
                            {defaultValues?.min?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} -{" "}
                            {defaultValues?.max?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </small>
                        )}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              )}

              <div className="field col-md-6 col-xs-12 my-3">
                <span className="p-float-label">
                  <Dropdown
                    className={classNames({
                      "w-100": true,
                      "p-invalid": isFormFieldValid(formik, "colorCodeValue"),
                    })}
                    value={formik.values.colorCode}
                    // disabled={vehicle?.colorCode}
                    name="colorCode"
                    optionValue={"colorCode"}
                    onChange={formik.handleChange}
                    options={colorlist}
                    optionLabel="colorDescription"
                    filter
                    showClear
                    filterBy="colorDescription"
                  />
                  <label className="w-100 label" htmlFor="">
                    {i18n.t("MotorEn.Color-1")}
                  </label>
                </span>
                {getFormErrorMessage(formik, "colorCode")}
              </div>

              {!hideDeduct && (
                <div className="field col-md-6 col-xs-12 my-3">
                  <span className="p-float-label">
                    <Dropdown
                      className={classNames({
                        "w-100": true,
                        "p-invalid": isFormFieldValid(formik, "deductible"),
                        "fm-tawuniya": true,
                      })}
                      placeholder={i18n.t("MotorEn.Deductible")}
                      name="deductible"
                      value={formik.values.deductible}
                      onChange={formik.handleChange}
                      options={config.deductable}
                      optionLabel="label"
                      optionValue="value"
                    />
                    <label htmlFor="" className="w-100 label">
                      {i18n.t("MotorEn.Deductible")}
                    </label>
                  </span>
                  {getFormErrorMessage(formik, "deductible")}
                </div>
              )}

              <div className="row d-flex justify-content-end actions">
                <Button
                  onClick={() => setCarToEdit(null)}
                  className="close-btn p-button-outlined py-1"
                >
                  {i18n.t("MotorEn.Close")}
                </Button>
                <Button
                  style={{ background: businessColor }}
                  type="submit"
                  className="save-btn py-1"
                  disabled={Object.keys(formik.errors).length > 0}
                >
                  {i18n.t("MotorEn.CONFIEM")}
                  {/* <ReloadIcon /> */}
                </Button>
              </div>
            </form>
          </React.Fragment>
        )}
      </div>
    </StyleWrapper>
    // ))
  );
};

export default VehiclePreview;
